import axios from "./index.service";

export default class ProfileService {
  static fetchUserProfile() {
    return axios({
      method: "GET",
      url: "/api/services/v1/student/me",
    });
  }

  static uploadProfilePicture(image) {
    var bodyFormData = new FormData();
    bodyFormData.append("imageFile", image);
    return axios({
      headers: { "Content-Type": "multipart/form-data" },
      method: "PUT",
      url: "/api/services/v1/student/upload-profile-picture",
      data: bodyFormData,
    });
  }

  static updateProfile(payload) {
    console.log({ payload });
    return axios({
      method: "PUT",
      url: "/api/services/v1/student/update-profile",
      data: payload,
    });
  }
}
